










import { defineComponent, onMounted } from '@vue/composition-api';
import ReviewList from '@/ui/components/review/ReviewList.vue';

import useProfileVariables from '@/ui/composables/profile/use-profile-variables';
import useProfileFunctions from '@/ui/composables/profile/use-profile-functions';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'ProfileReviews',
  components: {
    ReviewList,
  },
  computed: {
    ...mapState('profile', [
      'reviews',
      'profile',
    ]),
  },
  setup(_, { root }) {
    const profileVariables = useProfileVariables();
    const { watchAndLoad, loadMoreReviews } = useProfileFunctions(root.$store, profileVariables);

    onMounted(async () => {
      await watchAndLoad();
    });

    return {
      ...profileVariables,
      loadMoreReviews,
    };
  },
});
